import { render, staticRenderFns } from "./CustomFileDropzone.vue?vue&type=template&id=6605a4f8&scoped=true&"
import script from "./CustomFileDropzone.vue?vue&type=script&lang=js&"
export * from "./CustomFileDropzone.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileDropzone.vue?vue&type=style&index=0&id=6605a4f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605a4f8",
  null
  
)

export default component.exports